import { ref, computed } from 'vue'
import { quotes } from '@/data/quotes.js'
import { useI18n } from '@/i18n'

export function useQuotes() {
  const { currentLanguage } = useI18n()
  const currentQuoteIndex = ref({})
  
  // 为每种语言初始化随机索引
  Object.keys(quotes).forEach(lang => {
    currentQuoteIndex.value[lang] = Math.floor(Math.random() * quotes[lang].length)
  })
  
  const currentQuotes = computed(() => quotes[currentLanguage.value] || quotes['zh-CN'])
  const currentQuote = computed(() => currentQuotes.value[currentQuoteIndex.value[currentLanguage.value] || 0])
  
  const getRandomQuote = () => {
    const lang = currentLanguage.value
    const quotesArray = quotes[lang] || quotes['zh-CN']
    const currentIndex = currentQuoteIndex.value[lang] || 0
    
    let newIndex
    do {
      newIndex = Math.floor(Math.random() * quotesArray.length)
    } while (newIndex === currentIndex && quotesArray.length > 1)
    
    currentQuoteIndex.value[lang] = newIndex
    return quotesArray[newIndex]
  }
  
  const loadRandomQuote = () => {
    return getRandomQuote()
  }
  
  return {
    currentQuote,
    currentQuoteIndex,
    getRandomQuote,
    loadRandomQuote
  }
}